const state = {
  contabilista: {},
};

export default state;
